/**
 * Quando vale la pena rinfrescare il token Logto e ritentare lo scambio col backend.
 *
 * ⚠️ PERCHE' ESISTE, e perche' e' un file a se'. `runBackendExchange` (`lib/logto.ts`)
 * ritentava lo scambio **su qualsiasi fallimento**, senza guardare lo status:
 *
 *     if (!outcome.token) { const r = await refreshLogtoToken(); if (r) outcome = await postExchange(r); }
 *
 * Il refresh cura UNA causa sola: il token Logto in mano e' opaco o scaduto, cioe' un **401**.
 * Su tutto il resto e' lavoro sprecato che l'utente paga in attesa. Misurato il 2026-09-05 con
 * il monolite di staging giu' (503 da API Gateway): scambio 503 a **9,7 s** (timeout del
 * gateway) → grant `refresh_token` a Logto **200** a 10,5 s → secondo scambio per altri ~9 s
 * ⇒ **~19 s di rete e un grant Logto per schermata**, per un backend che era semplicemente
 * spento. La finestra di rifiuto da 30 s (`logto.ts`, `BACKEND_REFUSAL_WINDOW_MS`) scatta
 * **dopo** la coppia, quindi non protegge il primo giro.
 *
 * 🔑 **Non e' un cambio di disegno: e' allineare il codice alla sua intenzione gia' scritta.**
 * Il commento sopra `BACKEND_REFUSAL_WINDOW_MS` diceva gia' la regola giusta — *«503
 * dell'origine, rete caduta — e' potenzialmente transitorio e vale solo per una finestra
 * breve»* — e il ramo del refresh non la rispettava.
 *
 * ⚠️ E il costo peggiore non e' il tempo. **Con la rotazione dei refresh token accesa, ogni
 * 503 avrebbe consumato un refresh token per niente** — un grant riuscito, un token nuovo, e
 * uno scambio che fallisce comunque. La rotazione oggi e' SPENTA sull'app di produzione
 * (`logto.ts:563-573`), quindi il difetto e' latente e non attivo: e' esattamente il tipo di
 * difetto che si scopre il giorno in cui si accende un'altra impostazione.
 *
 * La funzione e' pura e sta qui, non in `logto.ts`, perche' `tools/verify-auth.ts` la eserciti
 * sotto Node: `logto.ts` legge `import.meta.env` e non e' importabile fuori da Vite.
 */

/**
 * `true` solo quando il fallimento e' attribuibile al TOKEN che abbiamo mandato.
 *
 * ⚠️ Elenco chiuso, e la regola opposta («tutto cio' che non e' 2xx») sarebbe piu' comoda e
 * sbagliata nei due versi: rinfrescare su 503 spreca un grant, e **non** rinfrescare su 401
 * lascia fuori un utente legittimo con un token appena scaduto.
 *
 * @param status lo status dello scambio; **0 = la richiesta non e' mai arrivata** (rete caduta)
 */
export function shouldRefreshAndRetryExchange(status: number): boolean {
  // 401 = il backend ha guardato il token e l'ha rifiutato. E' l'unico caso che un token
  // nuovo puo' cambiare.
  //
  // 403 NO: il backend ha capito CHI sei e ti nega comunque — un token nuovo dice la stessa
  // cosa. 5xx NO: non ha nemmeno guardato il token. 0 NO: la richiesta non e' arrivata, e un
  // grant a Logto su una rete caduta fallisce a sua volta, raddoppiando l'attesa.
  return status === 401;
}
